<template>
  <main class="w-full">
    <div
      class="post-slider-additional-content bg-overlay-strong has-mode mode-dark h-full p-8 relative z-50"
    >
      <h1 class="text-5xl mb-6">Blog</h1>
      <div class="row my-10">
        <button
          @click="tooglePostFrom"
          class="bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded"
        >
          {{ isEditing ? "Cancle" : "Add post" }}
        </button>
        <PostForm v-if="isEditing" />
      </div>
      <div class="row"></div>
      <ul class="mb-6" v-if="posts">
        <PostItem v-for="post in posts" :key="post.post_id" :post="post" />
      </ul>
    </div>
  </main>
</template>

<script>
import PostItem from "./components/PostItem";
import PostForm from "./components/PostForm";
export default {
  name: "Admin",
  components: {
    PostItem,
    PostForm,
  },
  data() {
    return {
      isEditing: false,
      msg: null,
      classAlert: null,
      post_id: null,
      post_index: null,
      posts: [],
      title: "",
      content: "",
      image: "",
      imgPlaceholder: "http://via.placeholder.com/300",
    };
  },
  created() {
    this.get();
  },
  methods: {
    tooglePostFrom() {
      this.isEditing = !this.isEditing;
    },
    get() {
      if (!this.posts.length) {
        this.$api
          .get("/blog")
          .then((res) => {
            this.posts = res.data;
          })
          .catch((err) => {
            console.log(err.response);
            this.msg = err.response.data.messages.error;
            this.classAlert = "danger";
          });
      }
    },
    save() {
      if (this.post_id) {
        this.update();
      } else {
        this.create();
      }
    },
    create() {
      const form = new FormData();
      form.append("title", this.title);
      form.append("description", this.content);
      form.append("featured_image", this.$refs.featured_image.files[0]);
      this.$api
        .post("/blog", form)
        .then((res) => {
          this.msg = "Post has been created";
          this.classAlert = "success";
          this.posts.unshift(res.data);
          this.cancel(true);
        })
        .catch((err) => {
          this.msg = err.response.data.messages.error;
          this.classAlert = "danger";
        });
    },
    update() {
      const form = new FormData();
      form.append("title", this.title);
      form.append("description", this.content);
      if (this.$refs.featured_image.files.length > 0)
        form.append("featured_image", this.$refs.featured_image.files[0]);
      this.$api
        .post("/blog/update/" + this.post_id, form)
        .then((res) => {
          this.msg = "Post has been updated";
          this.classAlert = "success";
          this.posts[this.post_index] = res.data;
          this.cancel(true);
        })
        .catch((err) => {
          this.msg = err.response.data.messages.error;
          this.classAlert = "danger";
        });
    },
    getPost(post_id, post_index) {
      this.cancel();
      this.post_id = post_id;
      this.post_index = post_index;
      this.$api.get("/blog/" + post_id).then((res) => {
        this.title = res.data.post_title;
        this.content = res.data.post_description;
        var image = res.data.post_featured_image;
        if (image != "") this.image = "http://umwlcms.text/api/assets/uploads/" + image;
        else this.image = "";
        window.scroll(0, 0);
      });
    },
    deletePost(id, index) {
      this.$api
        .delete("/blog/" + id)
        .then(() => {
          this.msg = "Post has been deleted";
          this.classAlert = "warning";
          this.cancel(true);
          this.posts.splice(index, 1);
          window.scroll(0, 0);
        })
        .catch((err) => {
          this.msg = err.response.data.messages.error;
          this.classAlert = "danger";
        });
    },
    updatePreview(event) {
      const file = event.target.files[0];
      this.image = URL.createObjectURL(file);
    },
    cancel(alertShow = false) {
      this.post_index = null;
      this.post_id = null;
      this.title = "";
      this.content = "";
      this.image = "";
      if (!alertShow) {
        this.msg = null;
        this.classAlert = null;
      }
    },
  },
};
</script>

<style>
body {
  background-color: #e1e1e1;
}
.form-wrapper {
  border-radius: 7px;
}
.form-wrapper label {
  font-weight: bold;
}
.errors li {
  list-style: none;
  width: 100%;
  text-align: center;
}
.errors ul {
  padding-left: 0;
  margin-bottom: 0;
}

@media (max-width: 768px) {
  .form-wrapper .text-right {
    text-align: center !important;
  }

  .form-wrapper .btn-primary {
    display: block;
    margin: 0 auto;
  }
}
</style>
